import { SubscriptionDetails } from 'state/store/subscription/subscriptionStore';

export type PlanOfferIdentity = {
  planId: string;
  code: string;
  displayName: string;
  prices: { priceId: string; interval: string }[];
};

export type SelectedPlanPrice = {
  priceId: string;
  interval: string;
};

const isSamePlan = (plan: PlanOfferIdentity, details: SubscriptionDetails): boolean =>
  details.planCode?.toLowerCase() === plan.code?.toLowerCase() ||
  details.planCode === plan.planId ||
  details.planName?.toLowerCase() === plan.displayName?.toLowerCase();

const resolveCurrentPriceId = (
  plan: PlanOfferIdentity,
  details: SubscriptionDetails
): string | undefined => {
  if (details.priceId) return details.priceId;
  if (!details.interval) return undefined;
  return plan.prices.find(
    (price) => price.interval.toLowerCase() === details.interval?.toLowerCase()
  )?.priceId;
};

/**
 * A catalogue offer is the current subscription only when both the plan
 * and the selected price match. Same plan + different priceId (monthly vs yearly)
 * is a different offer and should keep Select plan enabled.
 */
export const isCurrentPlanOffer = (
  plan: PlanOfferIdentity,
  selectedPrice: SelectedPlanPrice | null,
  details: SubscriptionDetails | null
): boolean => {
  if (!details?.subscriptionId) return false;
  if (!isSamePlan(plan, details)) return false;
  if (!selectedPrice) return true;

  const currentPriceId = resolveCurrentPriceId(plan, details);
  if (currentPriceId) return selectedPrice.priceId === currentPriceId;

  if (details.interval) {
    return selectedPrice.interval.toLowerCase() === details.interval.toLowerCase();
  }

  return false;
};
